import { isDev } from '../utils/utils';

const config = {
  API_MAIN: process.env.REACT_APP_API_URL,
  REDIRECT_AFTERAUTH: '/open-deals/management/2023-Q2',
  LANDING_PAGE_API: process.env.REACT_APP_LANDING_URL,
};

export { config };
